import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/Home.vue'
import Main from './components/Main.vue'
import ListA from './components/ListA.vue'
import RiskInfo from './components/Article/RiskInfo.vue'
import TermOfUse from './components/Article/TermOfUse.vue'
import PrivacyPolicy from './components/Article/PrivacyPolicy.vue'
import SiteMap from './components/SiteMap.vue'
import templatelist from './components/templatelist.vue'
Vue.use(Router)

var router = new Router({
  mode: 'history',
  routes: [

    {
      path: '/templatelist',
      name: 'templatelist',
      component: templatelist
    },
    {
      path: '/template-home',
      name: 'Home',
      meta: {
        title: 'Home Template'
      },
      component: Home,
      props: {
        'belongTo': 'template'
      }
    },
    {
      path: '/',
      name: 'Home',
      meta: {
        title: '主页 - 佳能商务科技（广东）'
      },
      component: ListA,
      props: {
        'belongTo': 'home'
      }
    },
    {
      path: '/main',
      name: 'Main',
      meta: {
        title: 'Main Template'
      },
      component: Main,
      props: {
        'belongTo': 'main'
      }
    },
    {
      path: '/sustainability',
      name: 'Sustainability',
      meta: {
        title: '可持续发展 - 佳能商务科技（广东）'
      },
      component: ListA,
      props: {
        'belongTo': 'Sustainability'
      }
    },
    {
      path: '/risk-info',
      name: 'RiskInfo',
      meta: {
        title: '风险管理 - 佳能商务科技（广东）'
      },
      component: RiskInfo,
      props: {
        'belongTo': 'RiskInfo'
      }
    },
    {
      path: '/terms-of-use',
      name: 'TermOfUse',
      meta: {
        title: '使用条款 - 佳能商务科技（广东）'
      },
      component: TermOfUse,
      props: {
        'belongTo': 'TermOfUse'
      }
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      meta: {
        title: '隐私政策 - 佳能商务科技（广东）'
      },
      component: PrivacyPolicy,
      props: {
        'belongTo': 'PrivacyPolicy'
      }
    },
    {
      path: '/SiteMap',
      name: 'SiteMap',
      meta: {
        title: 'SiteMap'
      },
      component: SiteMap,
      props: {
        'belongTo': 'SiteMap'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router.js